
import API from '../../../services/api';
function addNewUser(){
    this.isaddedinstitution = false;
    this.isaddedhost = false
    this.isaddedinstitutionhost = false
    this.isaddeduser = true;
    this.actiontitle = 'Add new User!'
    this.visible_actions = true;
}
function addNewInstitution(){
    this.isaddedhost = false
    this.isaddeduser = false
    this.isaddedinstitutionhost = false
    this.isaddedinstitution = true;
    this.actiontitle = 'Add new Institution!'
    this.visible_actions = true;
}
function addNewHost(){
    this.isaddedinstitution = false;
    this.isaddeduser = false
    this.isaddedinstitutionhost = false
    this.isaddedhost = true
    this.actiontitle = 'Add new Host!'
    this.visible_actions = true;
}
function addNewInstitutionHost(id,name){
    this.isaddedinstitution = false;
    this.isaddeduser = false
    this.isaddedhost = false
    this.actiontitle = `Add new host for ${name} institution!`
    this.isaddedinstitutionhost = true;
    this.selectedinstitutionid = id
    this.visible_actions = true;
}
function handleSelectChangeInstitutionHost(value){
    if(value == 1){
        this.isexisthost = true;
        this.isnewhost = false;
    }
    if(value == 2){
        this.isexisthost = false;
        this.isnewhost = true;
    }
}
function handleSubmitIns(e){
    e.preventDefault();
    this.form_inst.validateFields((err, values) => {
        if (!err) {
            values.application_id = this.$route.params.id;
            API.post(`/api/admin/institutions`,values)
            .then(response => {
                if(response.status == 302){
                    this.$message.error(response.data.message)
                }else{
                    this.getApplications()
                    this.visible_actions = false;
                    this.form_inst.resetFields();
                }        
            })
        }
    });
}
async function getInstitution(insId){
    API.get(`/api/admin/institutions/${insId}`)
    .then(res => { 
        this.institution = res.data
        this.detailsareset = true
    })
    .catch(error => console.log(error));
    console.log("sdcsdcsd",this.institution)
}
function handleSubmitInstitutionHost(e){
    e.preventDefault();
    this.form_institution_host.validateFields((err, values) => {
        if (!err) {
            values.institution_id = this.selectedinstitutionid
            values.application_id = this.$route.params.id
            API.post(`/api/admin/institutions/${values.existing_host}`,values)
            .then(response => {
                if(response.status == 302){
                    this.$message.error(response.data.message)
                }else{
                    this.getApplications()
                    this.visible_actions = false;
                    if(values.existing_host == 2){
                        this.form_institution_host.resetFields();
                    }
                }
            })
        }
    });
}
function handleSubmit(e) {
  e.preventDefault();
  this.form.validateFields((err, values) => {
    if (!err) {
        values.application_id = this.$route.params.id;
        API.post(`/api/admin/users`,values)
        .then(response => {
            if(response.status == 302){
                this.$message.error(response.data.message)
            }else{
                this.getApplications()
                this.visible_actions = false;
                this.resetForm()
            }
        })
    }
  });
}

function handleSubmitHost(e){
    e.preventDefault();
    this.form_host.validateFields((err, values) => {
        if (!err) {
            values.application_id = this.$route.params.id;

            API.put(`/api/admin/hosts`,values)
            .then(response => {
                if(response.status == 302){
                    this.$message.error(response.data.message)
                }else{
                    this.getApplications()
                    this.visible_actions = false;
                    this.form_host.resetFields();
                }
            })
        }
    });
}

function resetForm(){
    this.form.resetFields();
}
function handleSelectChange(value) {
    if(value == 2){
        this.selectedpersonal = true;
        this.selectedinstitution = false;
    }
    if(value == 3){
        if(this.application.institutions.length){
            this.selectedinstitution = true;
            this.selectedpersonal = false;
        }
    }
    if(value == 1){
        this.selectedpersonal = false;
        this.selectedinstitution = false;
    }
}

async function getApplications(){
    API.get(`/api/admin/applications/${this.$route.params.id}`)
    .then(res => { 
        this.application = res.data[0];
        this.application.active_hosts = this.application.hosts.filter(item => item.active == 1)
        this.application.inactive_hosts = this.application.hosts.filter(item => item.active == 0)
        this.loading = true
    })
    .catch(error => console.log(error));
}
function showModal(institution_id,insname) {
    this.modal_title = `Institution of ${insname} details!`
    this.getInstitution(institution_id)
    this.visible = true;
}

function handleCancel(e) {
  this.visible = false;
  console.log(this.visible)
}
function handleCancelAction(e) {
    this.visible_actions = false;
}
function data() {
    return {
        loading:false,
        application:{},
        visible: false,
        visible_actions: false,
        confirmLoading: false,
        modal_title:'',
        actiontitle:'',
        institution:{},
        detailsareset:false,
        formLayout: 'horizontal',
        form: this.$form.createForm(this),
        form_inst: this.$form.createForm(this),
        form_host: this.$form.createForm(this),
        form_institution_host:this.$form.createForm(this),
        selectedpersonal: false,
        selectedinstitution:false,
        isaddeduser:false,
        isaddedinstitution:false,
        isaddedhost:false,
        isaddedinstitutionhost:false,
        isexisthost:false,
        isnewhost:false,
        selectedinstitutionid:null,
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },

    };
}

function deleteInstitution(instid){
    API.delete(`/api/admin/institutions/${instid}?appid=${this.$route.params.id}`)
    .then(response => {
        this.getApplications()
    })
}
function deleteUser(userid){
    API.delete(`/api/admin/users/${userid}?appid=${this.$route.params.id}`)
    .then(response => {
        this.$message.success('Deleted successfully!')
        this.getApplications()
    })
}
function deleteHost(hostid){
    API.delete(`/api/admin/hosts/${hostid}?appid=${this.$route.params.id}`)
    .then(response => {
        this.$message.success('Deleted successfully!')
        this.getApplications()
    })
}
function RemoveHost(hostid){
    API.put(`/api/admin/hosts/${hostid}?appid=${this.$route.params.id}`)
    .then(response => {
        this.$message.success('Remove successfully!')
        this.getApplications()
    })
}

function cancel(e) {
    //this.$message.error('Click on No');
    this.visible = false
}
export { 
    addNewUser,
    addNewInstitution,
    addNewHost,
    addNewInstitutionHost,
    handleSubmit,
    handleSubmitIns,
    handleSubmitHost,
    handleSubmitInstitutionHost,
    resetForm,
    handleSelectChange,
    handleSelectChangeInstitutionHost,
    getApplications,
    showModal,
    getInstitution,
    handleCancel,
    handleCancelAction,
    deleteInstitution,
    cancel,
    deleteUser,
    deleteHost,
    data,
    RemoveHost
};